import {domMax as domMaxFeature} from 'motion/react';

export const domMax = domMaxFeature;
